/**
 * @desc 样品确认-更新(保存草稿)
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(
  body: defs.basics.ProductConfirmRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/productConfirm/update`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
